<template>
  <div id="error">
    <h2>未检测到人脸</h2>
    <div @click="testAgain" class="btn">请重新检测</div>
  </div>
</template>

<script>
export default {
  methods: {
    testAgain () {
      this.$router.push('upload')
    }
  }
}
</script>

<style>
#error {
  margin-top: 30vh;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.btn{
  width:50vw;
  height: 15vw;
  padding: 4vw;
  margin-top: 10vw;
  background-color: #64c8c8;
  border-radius: 7vw;
  border:none;
  outline: none;
  font-size: 7vw;
  line-height: 7vw;
  color: #fff;
  text-align: center;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/Erroring/index.vue